<template>
  <div>
    <v-row class="align-items-center" no-gutters>
      <v-col sm="9">
        <span :class="{ 'd-block text-center': $vuetify.breakpoint.xs }">
          &copy; {{ $store.state.global.year }} ClearSale S.A. Todos os direitos
          reservados.
        </span>
        <a
          :class="['privacy-link', { 'serasa-theme': isSerasa, 'text-center': $vuetify.breakpoint.xs }]"
          href="https://br.clear.sale/politica-de-privacidade"
          target="_blank"
        >
          Política de Privacidade
        </a>
      </v-col>
      <v-col
        :class="{ 'text-right': true, 'd-none': $vuetify.breakpoint.xs }"
        sm="3"
        style="line-height: 0.8;"
      >
        <template>
          <a
            v-for="obj in media"
            :class="['social-link', { 'serasa-theme': isSerasa }]"
            :href="obj.link"
            :key="obj.id"
            style="text-decoration: none;"
          >
            <cs-icon
              :color="isSerasa ? '#94A3B8' : 'black'"
              :size="obj.size"
              :value="obj.icon"
            />
          </a>
        </template>
      </v-col>
    </v-row>
       <div class="clear_background" v-if="!isSerasa"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import csIcon from "@/components/campos/csIcon.vue";

export default {
  components: {
    csIcon,
  },
  computed: {
    ...mapGetters(["isSerasa"]),
  },
  data: () => ({
    media: [
      {
        icon: "facebook",
        link: "https://www.facebook.com/clearsale",
        size: "1.5rem",
      },
      {
        icon: "instagram",
        link: "https://www.instagram.com/clearsale",
        size: "1.5rem",
      },
      {
        icon: "youtube",
        link: "https://www.youtube.com/user/ClearSaleBrasil",
        size: "1.5rem",
      },
      {
        icon: "linkedin",
        link: "https://www.linkedin.com/company/clearsale",
        size: "1.5rem",
      },
    ],
  }),
};
</script>

<style scoped>
.privacy-link {
  color: #0075ff;
  display: inline-block;
}

.text-center {
  display: block;
  text-align: center;
}

.social-link {
  color: inherit;
  margin-right: 0.5rem;
}

.serasa-theme {
  color: var(--v-feedback-link-base) !important;
}

.social-link:last-child {
  margin-right: 0 !important;
}

.clear_background {
  z-index: -1;
  width: 67%;
  height: 60%;
  left: -480px;

  bottom: 0;
  position: fixed;
  background: url("../../public/img/clear_background.png");
  background-repeat: no-repeat;
}

@media screen and (max-width: 1360px) {
  .clear_background {
    background-image: none;

  }
}
</style>
